(function () {
    if (window.__tlGiftQtyLock || !window.fetch) return;
    window.__tlGiftQtyLock = true;

    var config = Object.assign({
        // line item properties marking a gift line
        giftProperties: [
            '_salepify-embed',
            '_salepify-advanced-fg',
            '_salepify-bogo',
            '_salepify-progress-bar',
            '_salepify-discount-code-fg'
        ],
        // true: customer can still remove the gift (quantity 0)
        allowRemove: false,
        // {title} is replaced by the gift title
        errorMessage: "You can't change the quantity of {title}.",
        debug: false
    }, window.tlGiftQtyLockConfig || {});

    var CART_ACTION = /\/cart\/(add|change|update|clear)(\.js|\.json)?$/;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var nativeFetch = window.fetch.bind(window);
    var checkedConfigs = new WeakSet();
    var lastCart = null;

    function log() {
        if (config.debug) console.log.apply(console, ['[TL gift qty lock]'].concat([].slice.call(arguments)));
    }

    function getCart() {
        return nativeFetch(root + 'cart.js?app=salepify-qty-lock', { credentials: 'same-origin' })
            .then(function (res) { return res.json(); })
            .then(function (cart) {
                lastCart = cart;
                return cart;
            });
    }

    function getCartAction(url) {
        if (url instanceof URL) url = url.href;
        else if (url && typeof url === 'object' && url.url) url = url.url;
        if (typeof url !== 'string' || url.indexOf('app=salepify') > -1) return null;

        var path = url.split('#')[0].split('?')[0].replace(/\/+$/, '');
        var match = path.match(CART_ACTION);
        return match ? match[1] : null;
    }

    // Same check as Free gift: gift property, or a line discounted by a Free gift rule code
    function isGiftLine(item) {
        if (!item) return false;

        var properties = item.properties || {};
        for (var i = 0; i < config.giftProperties.length; i++) {
            var value = properties[config.giftProperties[i]];
            if (value != null && value !== '') return true;
        }

        try {
            var freeGift = window.tlFreeGiftOffer;
            if (freeGift && typeof freeGift.checkLineItemIsGift === 'function' && freeGift.checkLineItemIsGift(item)) {
                return item.price == 0 || item.total_discount > 0;
            }
        } catch (e) {}

        return false;
    }

    // Returns the quantity to send instead, or null when the new quantity is allowed
    function lockedQuantity(item, quantity) {
        if (!isGiftLine(item)) return null;

        var newQuantity = Number(quantity);
        if (isNaN(newQuantity) || newQuantity === item.quantity) return null;
        if (config.allowRemove && newQuantity === 0) return null;

        return item.quantity;
    }

    function findLineByKeyOrVariant(items, id) {
        id = String(id);
        for (var i = 0; i < items.length; i++) {
            if (items[i].key === id) return items[i];
        }

        // Variant id: only lock when every line of this variant is a gift (can't tell which line Shopify updates)
        var lines = items.filter(function (item) { return String(item.id) === id; });
        return lines.length && lines.every(isGiftLine) ? lines[0] : null;
    }

    function findChangeLine(items, line, id) {
        if (line != null && line !== '') return items[Number(line) - 1] || null;
        if (id != null && id !== '') return findLineByKeyOrVariant(items, id);
        return null;
    }

    function getEntries(body) {
        if (typeof body === 'string') {
            var text = body.trim();
            if (text.charAt(0) === '{') {
                try {
                    return { type: 'json', data: JSON.parse(text) };
                } catch (e) {
                    return null;
                }
            }
            return text.indexOf('=') > -1 ? { type: 'query', entries: Array.from(new URLSearchParams(text)) } : null;
        }
        if (body instanceof URLSearchParams) return { type: 'params', entries: Array.from(body) };
        if (body instanceof FormData) return { type: 'formdata', entries: Array.from(body) };
        return null;
    }

    function buildBody(parsed) {
        if (parsed.type === 'json') return JSON.stringify(parsed.data);
        if (parsed.type === 'query') return new URLSearchParams(parsed.entries).toString();
        if (parsed.type === 'params') return new URLSearchParams(parsed.entries);

        var formData = new FormData();
        parsed.entries.forEach(function (entry) { formData.append(entry[0], entry[1]); });
        return formData;
    }

    // Returns { blockedItem } to reject the request, { body } to send a patched body, or {} to send as is.
    // rewriteOnly: never reject, reset the gift quantity instead (XHR)
    function inspectRequest(action, body, cart, rewriteOnly) {
        var parsed = getEntries(body);
        if (!parsed) return {};

        var items = cart.items || [];
        var changed = false;
        var item, fixed;

        if (parsed.type === 'json') {
            var data = parsed.data;

            if (action === 'change' && data.quantity != null) {
                item = findChangeLine(items, data.line, data.id);
                fixed = lockedQuantity(item, data.quantity);
                if (fixed !== null) {
                    if (!rewriteOnly) return { blockedItem: item };
                    data.quantity = fixed;
                    changed = true;
                }
            }

            if (data.updates && typeof data.updates === 'object') {
                Object.keys(data.updates).forEach(function (key) {
                    var line = Array.isArray(data.updates) ? items[Number(key)] : findLineByKeyOrVariant(items, key);
                    var lineFixed = lockedQuantity(line, data.updates[key]);
                    if (lineFixed !== null) {
                        data.updates[key] = lineFixed;
                        changed = true;
                    }
                });
            }
        } else {
            var entries = parsed.entries;
            var line = null, id = null, quantityIndex = -1, updateIndex = 0;

            entries.forEach(function (entry, index) {
                if (entry[0] === 'line') line = entry[1];
                else if (entry[0] === 'id') id = entry[1];
                else if (entry[0] === 'quantity') quantityIndex = index;
            });

            if (action === 'change' && quantityIndex > -1) {
                item = findChangeLine(items, line, id);
                fixed = lockedQuantity(item, entries[quantityIndex][1]);
                if (fixed !== null) {
                    if (!rewriteOnly) return { blockedItem: item };
                    entries[quantityIndex][1] = String(fixed);
                    changed = true;
                }
            }

            entries.forEach(function (entry) {
                var match = entry[0].match(/^updates\[(.*)\]$/);
                if (!match) return;

                var updateLine = match[1] === '' ? items[updateIndex++] : findLineByKeyOrVariant(items, match[1]);
                var lineFixed = lockedQuantity(updateLine, entry[1]);
                if (lineFixed !== null) {
                    entry[1] = String(lineFixed);
                    changed = true;
                }
            });
        }

        return changed ? { body: buildBody(parsed) } : {};
    }

    function createErrorResponse(item) {
        var message = config.errorMessage.replace('{title}', item.product_title || item.title || '');
        return new Response(JSON.stringify({
            status: 422,
            message: message,
            description: message,
            errors: message
        }), {
            status: 422,
            headers: { 'Content-Type': 'application/json' }
        });
    }

    function wrapFetch(innerFetch) {
        var lockedFetch = function (resource, options) {
            var args = [].slice.call(arguments);
            var action = getCartAction(resource);

            if (!action) return innerFetch.apply(window, args);

            var refreshCart = function (res) {
                getCart().catch(function () {});
                return res;
            };

            // add / clear, empty body, or already checked by an outer wrapper
            if ((action !== 'change' && action !== 'update') || !options || !options.body || checkedConfigs.has(options)) {
                return innerFetch.apply(window, args).then(refreshCart);
            }

            return getCart().then(function (cart) {
                var result = inspectRequest(action, options.body, cart, false);

                if (result.blockedItem) {
                    log('Blocked', action, result.blockedItem);
                    return createErrorResponse(result.blockedItem);
                }

                if (result.body !== undefined) {
                    log('Reset gift quantity', action, result.body);
                    options.body = result.body;
                }
                checkedConfigs.add(options);

                return innerFetch.apply(window, args).then(refreshCart);
            }, function () {
                return innerFetch.apply(window, args);
            });
        };
        lockedFetch.__tlGiftQtyLock = true;
        return lockedFetch;
    }

    // Keep our wrapper outermost: every fetch assigned later is wrapped again
    var currentFetch = wrapFetch(window.fetch);
    try {
        Object.defineProperty(window, 'fetch', {
            configurable: true,
            enumerable: true,
            get: function () { return currentFetch; },
            set: function (fn) {
                currentFetch = typeof fn === 'function' && !fn.__tlGiftQtyLock ? wrapFetch(fn) : fn;
            }
        });
    } catch (e) {
        window.fetch = currentFetch;
    }

    // XHR (jQuery themes): reset gift quantities in the body
    if (window.XMLHttpRequest) {
        var originalOpen = XMLHttpRequest.prototype.open;
        var originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function (method, url, async) {
            var isSync = arguments.length > 2 && async === false;
            this.__tlGiftQtyLockAction = isSync ? null : getCartAction(url);
            return originalOpen.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function (body) {
            var xhr = this;
            var action = xhr.__tlGiftQtyLockAction;

            if (action) {
                xhr.addEventListener('loadend', function () { getCart().catch(function () {}); });
            }
            if ((action !== 'change' && action !== 'update') || body == null) {
                return originalSend.apply(xhr, arguments);
            }

            getCart().then(function (cart) {
                var result = inspectRequest(action, body, cart, true);
                if (result.body !== undefined) log('Reset gift quantity (XHR)', action, result.body);
                originalSend.call(xhr, result.body !== undefined ? result.body : body);
            }, function () {
                originalSend.call(xhr, body);
            });
        };
    }

    // Cart page form submit without ajax
    document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!lastCart || !(form instanceof HTMLFormElement)) return;

        var action = (form.getAttribute('action') || '').split('#')[0].split('?')[0].replace(/\/+$/, '');
        if (!/\/cart(\/update)?$/.test(action)) return;

        var items = lastCart.items || [];
        var updateIndex = 0;

        Array.from(form.elements).forEach(function (input) {
            var match = (input.name || '').match(/^updates\[(.*)\]$/);
            if (!match) return;

            var line = match[1] === '' ? items[updateIndex++] : findLineByKeyOrVariant(items, match[1]);
            var fixed = lockedQuantity(line, input.value);
            if (fixed !== null) {
                log('Reset gift quantity (form)', line.key);
                input.value = fixed;
            }
        });
    }, true);

    getCart().catch(function () {});
})();
